<template>
  <SfModalPortal
    modal-id="confirm-reassign-check-modal"
    size="xs"
    @opened="onOpen"
    @close="onClose"
  >
    <template #title
      >{{ I18n.t('components.ledger_check_list_user.reassign_title') }}
    </template>

    <template #body>
      <div class="tw-p-4">
        <p
          v-dompurify-html="
            I18n.t('components.ledger_check_list_user.reassign_info_1', {
              new_name: newName,
              initial_name: initialName,
            })
          "
          class="tw-mb-4"
        ></p>
        <p
          v-dompurify-html="
            I18n.t('components.ledger_check_list_user.reassign_info_2', {
              initial_name: initialName,
            })
          "
          class="tw-mb-0"
        ></p>
      </div>
    </template>

    <template #footer>
      <div class="tw-w-full">
        <div class="tw-flex tw-justify-center">
          <SfButtonDs @click="onClose">
            {{ I18n.t('common.cancel') }}
          </SfButtonDs>
          <SfButtonDs variant="primary" class="tw-ml-2" @click="onConfirm">
            {{ I18n.t('components.ledger_check_list_user.reassign_confirm') }}
          </SfButtonDs>
        </div>
      </div>
    </template>
  </SfModalPortal>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { SfModalPortal } from '@app/shared/vue/components/sf-modal'
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import type { ConfirmReassignCheckPayload } from '@app/types'

const I18n = useI18n()
const initialName = ref<string>('')
const newName = ref<string>('')

const onOpen = (params: ConfirmReassignCheckPayload) => {
  initialName.value = params.initialName
  newName.value = params.newName
}

const onConfirm = () => {
  window.eventHub.$emit('confirm-reassign-check')
  onClose()
}

const onClose = () => {
  window.modalCitizen.closeModalPortal()
  initialName.value = ''
  newName.value = ''
}
</script>
